import React, { useState } from "react";
import { Api } from "../api/api";

export const KfcCheckout = (props) => {
  const [active, setActive] = useState(false);

  // 查看購物車清單 
  const CheckoutShppingCart = () => {
    setActive(!active);
  };

 // 確認結帳
 const WantBuy = async(e) => {
  e.preventDefault();

  const res = Api({
    orderId: e.target[1].value,
    memo: e.target[2].value,
    amount: parseInt(e.target[3].value) * 100,
  })

  Promise.resolve(res).then((response) => {
      console.log("response", response);

      if (response.data.resultCode === "0000") {
        window.open(response.data.resultMap.url);
      }
  })
  .catch((value) => {
      console.log("value", value.response);
  });
 };

  return (
    <div className="GoShopping">
      <button type="button" className="ShoppingDot" onClick={CheckoutShppingCart}>選擇</button>
      <form  className={active ? "KfcCheckoutAvtive KfcCheckout": "KfcCheckout"}  onSubmit={(e)=>{ WantBuy(e) }}>
        <div className="AllMenu">
          <nav>
            <p>购物车清单</p>
            <button type="button" onClick={CheckoutShppingCart} />
          </nav>
          <div className="AllMenuAll">
            <div>
              <div>
                <p>商户订单号</p>
                <input disabled name="orderid" value={"KFC"+ String(new Date().getFullYear())+ String(new Date().getMonth()) + String(new Date().getDate())+ String(new Date().getHours())+ String(new Date().getMinutes()) + String(new Date().getSeconds() + Math.floor(Math.random(100,999)))}/>
              </div>
              <div>
                <p>商品名称：</p>
                <input disabled name="memo" value={props.items.name}/>
              </div>
              <div>
                <p>付款金额</p>
                <input disabled name="amount" value={props.items.price}/>
              </div>
            </div>
          </div>
          <footer>
            <button type="submit">确认付款</button>
          </footer>
        </div>
      </form>
    </div>
  );
};
